import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class RedirectGuard implements CanActivate {
  constructor(private router: Router) {}
  

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const vParam = route.queryParams['v'];
    const path = state.url;
    console.log(path);

    if (vParam?.toUpperCase() === 'MTNFLIGHT10') {
      window.location.href = `https://connect.justgo.co.za/mtn?v=${vParam}`;
      return false;
    }

    // Redirect for /_admin/index.php
    if (path === '/_admin/index.php') {
      window.location.href = 'https://www.api-connect.justgo.co.za/_admin/index.php';
      return false;
    }

    return true;
  }
}

